import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MentorValidationPointsHistorySubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function formatDate(d) {
  if (!d) return '—';
  const date = new Date(d);
  return date.toLocaleString('ru-RU');
}

const TRANSACTION_TYPE_LABELS = {
  add: 'Добавление вопроса',
  edit: 'Изменение вопроса',
  delete: 'Удаление вопроса',
};

function getTransactionTypeLabel(value) {
  return value && TRANSACTION_TYPE_LABELS[value] ? TRANSACTION_TYPE_LABELS[value] : value || '—';
}

function MentorValidationPointsHistorySubTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterMentorId, setFilterMentorId] = useState('');
  const [deletingId, setDeletingId] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (filterMentorId) params.set('mentor_id', filterMentorId);
      const url = `${API_URL}/api/mentor-validation-points-history${params.toString() ? `?${params.toString()}` : ''}`;
      const res = await axios.get(url);
      setItems(res.data);
      setError(null);
    } catch (err) {
      setError('Ошибка загрузки: ' + (err.response?.data?.detail || err.message));
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterMentorId]);

  const handleDelete = async (recordId) => {
    if (!window.confirm('Удалить эту запись истории?')) return;
    setDeletingId(recordId);
    try {
      await axios.delete(`${API_URL}/api/mentor-validation-points-history/${recordId}`);
      fetchData();
    } catch (err) {
      setError('Ошибка удаления: ' + (err.response?.data?.detail || err.message));
    } finally {
      setDeletingId(null);
    }
  };

  if (loading) {
    return <div className="mentor-points-history-loading">Загрузка...</div>;
  }

  return (
    <div className="mentor-validation-points-history-sub-tab">
      <div className="mentor-points-history-header">
        <h2>История начисления очков</h2>
        <button type="button" className="btn btn-secondary" onClick={fetchData}>
          Обновить
        </button>
      </div>
      <p className="mentor-points-history-description">
        Записи добавляются автоматически при начислении очков. Редактирование и добавление записей недоступны; можно только удалять.
      </p>
      <div className="mentor-points-history-filters">
        <input
          type="number"
          placeholder="ID ментора"
          value={filterMentorId}
          onChange={(e) => setFilterMentorId(e.target.value)}
          className="filter-input"
        />
      </div>
      {error && <div className="mentor-points-history-error">{error}</div>}
      {items.length === 0 && !error ? (
        <div className="mentor-points-history-empty">Нет записей.</div>
      ) : (
        <div className="mentor-points-history-table-wrap">
          <table className="mentor-points-history-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>ID ментора</th>
                <th>Логин</th>
                <th>Тип операции</th>
                <th>ID вопроса</th>
                <th>Очков</th>
                <th>Дата</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>{row.mentor_id}</td>
                  <td>{row.mentor_login ?? '—'}</td>
                  <td>{getTransactionTypeLabel(row.transaction_type)}</td>
                  <td>{row.question_id ?? '—'}</td>
                  <td>{row.points_amount}</td>
                  <td>{formatDate(row.operation_date)}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDelete(row.id)}
                      disabled={deletingId === row.id}
                      title="Удалить запись"
                    >
                      {deletingId === row.id ? '…' : 'Удалить'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default MentorValidationPointsHistorySubTab;
